export default __webpack_public_path__ + "static/media/pro_bull.7ba63847.png";